export const generateRobovoiceId = (itemId, answer) => {
  let suffix = answer.replace(/\./g, '');
  suffix = suffix.replace(/ /g, '_');
  if (suffix[suffix.length - 1] === '_') {
    suffix = suffix.substring(0, suffix.length - 1);
  }

  return `${itemId}_${suffix}`;
};

export const generateListOfItems = ({ completeSet, seenItemIds, masteredItemIds, desiredLength }) => {
  const unseenItems = [];
  const seenItems = [];
  const masteredItems = [];
  const listOfItems = [];

  for (let i = 0; i < completeSet.length; i++) {
    const currentItemInSet = completeSet[i];
    if (masteredItemIds.includes(currentItemInSet.id)) {
      masteredItems.push(currentItemInSet);
    } else if (seenItemIds.includes(currentItemInSet.id)) {
      seenItems.push(currentItemInSet);
    } else {
      unseenItems.push(currentItemInSet);
    }
  }

  const usedUnseenItems = unseenItems.length > 0;

  for (let i = 0; i < desiredLength; i++) {
    if (unseenItems.length > 0) {
      listOfItems.push(unseenItems.shift());
    } else if (seenItems.length > 0) {
      listOfItems.push(seenItems.shift());
    } else {
      listOfItems.push(masteredItems.shift());
    }
  }

  return {
    listOfItems,
    usedUnseenItems,
  };
};
